var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 17.75C12.5 15.9551 13.9551 14.5 15.75 14.5H20C20.4142 14.5 20.75 14.1642 20.75 13.75C20.75 13.3358 20.4142 13 20 13H15.75C13.1266 13 11 15.1266 11 17.75V18V24V24.25C11 26.8734 13.1266 29 15.75 29H24.25C26.8734 29 29 26.8734 29 24.25V23C29 22.5858 28.6642 22.25 28.25 22.25C27.8358 22.25 27.5 22.5858 27.5 23V24.25C27.5 26.0449 26.0449 27.5 24.25 27.5H15.75C13.9551 27.5 12.5 26.0449 12.5 24.25V24H14C15.1298 24 16.1137 23.3755 16.6254 22.4528C16.8641 22.0224 17 21.5271 17 21C17 19.3431 15.6569 18 14 18H12.5V17.75ZM12.5 19.5V22.5H14C14.8284 22.5 15.5 21.8284 15.5 21C15.5 20.1716 14.8284 19.5 14 19.5H12.5Z",
    fill: "#6D757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9689 21.6687C25.4053 22.1104 24.5947 22.1104 24.0311 21.6687L20.5642 18.9514C19.4513 18.0791 20.0952 16.3513 21.5331 16.3513H22.8137L23.6563 11.1043C23.7584 10.469 24.329 10 25 10C25.671 10 26.2416 10.469 26.3437 11.1043L27.1863 16.3513H28.4669C29.9048 16.3513 30.5487 18.0791 29.4358 18.9514L25.9689 21.6687Z",
    fill: "#6D757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9689 21.6687C25.4053 22.1104 24.5947 22.1104 24.0311 21.6687L20.5642 18.9514C19.4513 18.0791 20.0952 16.3513 21.5331 16.3513H22.8137L23.6563 11.1043C23.7584 10.469 24.329 10 25 10C25.671 10 26.2416 10.469 26.3437 11.1043L27.1863 16.3513H28.4669C29.9048 16.3513 30.5487 18.0791 29.4358 18.9514L25.9689 21.6687ZM21.5331 17.817L25 20.5343L28.4669 17.817H27.1863C26.4312 17.817 25.7889 17.2892 25.6741 16.5742L25 12.3767L24.3259 16.5742C24.2111 17.2892 23.5688 17.817 22.8137 17.817H21.5331Z",
    fill: "#6D757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeposit);
export default __webpack_public_path__ + "static/media/icon-deposit.50101b2940ed0db3c810763ad22b3b18.svg";
export { ForwardRef as ReactComponent };